<nav
  [ngClass]="menuService.showSideBar ? 'w-52 xl:w-64' : 'w-[70px]'"
  class=" shadow-custom border-r-1.5 border-light-gray scrollbar-thumb-rounded scrollbar-track-rounded hidden h-full flex-col justify-between  bg-card pt-4 transition-all duration-300 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-card lg:flex">
  <div class="transition-all duration-300" [ngClass]="menuService.showSideBar ? 'pl-5 pr-2.5' : 'p-3.5'">
    <!-- Logo -->
    <div class="relative  h-[66px]">
<!--      <div class="flex items-center" >-->
<!--        <a-->
<!--          [routerLink]="'/'"-->
<!--          class="flex cursor-pointer items-center justify-center rounded p-2 focus:outline-none focus:ring-1">-->
<!--          <img src="assets/images/logo.svg" class=" transition-all duration-300 "-->
<!--            [ngClass]="{'w-[40px] h-[40px]': menuService.showSideBar,-->
<!--                        'w-[30px] h-[30px]': !menuService.showSideBar-->
<!--            }"-->
<!--          >-->
<!--        </a>-->
<!--&lt;!&ndash;        <b class="ml-1 pl-2 text-sm font-bold text-foreground">&ndash;&gt;-->
<!--&lt;!&ndash;          displayName&ndash;&gt;-->
<!--&lt;!&ndash;        </b>&ndash;&gt;-->
<!--      </div>-->
      <button
        (click)="toggleSidebar()"
        class="absolute right-0 -mr-6 z-10 p-2 border border-light-gray rounded-full flex h-7 w-7 items-center justify-center bg-white  text-muted-foreground/50 transition-all duration-200 focus:outline-none hover:text-muted-foreground"
        [ngClass]="{ 'rotate-180': !menuService.showSideBar }">
        <img src="assets/icons/base/16.svg" alt="">

      </button>
    </div>

    <!-- Separator -->
<!--    <div class="">-->
<!--      <div class="h-[0px] border border-light-gray"></div>-->
<!--    </div>-->

    <!-- Menu Items -->
    <app-admin-sidebar-menu></app-admin-sidebar-menu>
  </div>

</nav>
